import React, { useEffect, useState } from "react";
import "./Hero.css";
import portfolioPic2 from "../../assets/portfolioPic2.JPEG";
import { useTranslation } from "react-i18next";

const Hero = ({ id }) => {
  const [loaded, setLoaded] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <div id={id} className={`hero ${loaded ? "is-loaded" : ""}`}>
      <img src={portfolioPic2} alt="" className="hero-photo" />
      <h1>
        <span>{t("hero.titlePart2")}</span> {t("hero.titlePart3")}
      </h1>
      <p>{t("hero.subtitle")}</p>
    </div>
  );
};

export default Hero;
